export default __webpack_public_path__ + "static/media/istid.2e92ebb9.jpg";